import { render, staticRenderFns } from "./BxAccountModal.vue?vue&type=template&id=a2ccc54e&"
import script from "./BxAccountModal.vue?vue&type=script&lang=js&"
export * from "./BxAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports